export default function About() {
  return (
    <section id="about" className="py-20 bg-gradient-to-br from-gray-50 to-gray-100">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <div>
            <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
              Welcome to Basic Rentals
            </h2>
            <p className="text-lg text-gray-700 mb-6 leading-relaxed">
              We understand that reliable transportation is essential for your livelihood. That's why we've built 
              our business around serving <strong>gig workers</strong> and <strong>people facing transportation challenges</strong>.
            </p>
            <p className="text-lg text-gray-700 mb-6 leading-relaxed">
              Whether you're driving for rideshare services, making deliveries, or simply need dependable wheels 
              to get to work, we're here to help. Our mission is simple: provide quality, affordable vehicles 
              that keep you moving forward.
            </p>
            <p className="text-lg text-gray-700 mb-8 leading-relaxed">
              No complicated contracts. No hidden fees. Just honest service and reliable cars at a price that 
              works for your budget. We believe everyone deserves access to safe, dependable transportation.
            </p>

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
              <div className="flex items-start gap-4">
                <div className="w-12 h-12 flex items-center justify-center bg-teal-100 rounded-lg flex-shrink-0">
                  <i className="ri-team-line text-2xl text-teal-600"></i>
                </div>
                <div>
                  <h3 className="font-semibold text-gray-900 mb-1">Gig Worker Friendly</h3>
                  <p className="text-sm text-gray-600">Flexible terms designed for your work schedule</p>
                </div>
              </div>

              <div className="flex items-start gap-4">
                <div className="w-12 h-12 flex items-center justify-center bg-teal-100 rounded-lg flex-shrink-0">
                  <i className="ri-hand-heart-line text-2xl text-teal-600"></i>
                </div>
                <div>
                  <h3 className="font-semibold text-gray-900 mb-1">Community Focused</h3>
                  <p className="text-sm text-gray-600">Supporting those with transportation needs</p>
                </div>
              </div>

              <div className="flex items-start gap-4">
                <div className="w-12 h-12 flex items-center justify-center bg-teal-100 rounded-lg flex-shrink-0">
                  <i className="ri-price-tag-3-line text-2xl text-teal-600"></i>
                </div>
                <div>
                  <h3 className="font-semibold text-gray-900 mb-1">Transparent Pricing</h3>
                  <p className="text-sm text-gray-600">One simple rate, no surprises</p>
                </div>
              </div>

              <div className="flex items-start gap-4">
                <div className="w-12 h-12 flex items-center justify-center bg-teal-100 rounded-lg flex-shrink-0">
                  <i className="ri-car-line text-2xl text-teal-600"></i>
                </div>
                <div>
                  <h3 className="font-semibold text-gray-900 mb-1">Quality Vehicles</h3>
                  <p className="text-sm text-gray-600">Well-maintained, reliable cars</p>
                </div>
              </div>
            </div>
          </div>

          <div className="relative">
            <div className="w-full h-[600px] rounded-2xl overflow-hidden shadow-2xl">
              <img
                src="https://public.readdy.ai/ai/img_res/75ced53a2bf31e827876927fcbd53e6b.jpg"
                alt="Our Community"
                className="w-full h-full object-cover object-center"
              />
            </div>
            <div className="absolute -bottom-6 -left-6 bg-teal-600 text-white p-8 rounded-xl shadow-xl max-w-xs">
              <p className="text-3xl font-bold mb-2">$250/week</p>
              <p className="text-sm text-teal-100">Simple pricing that works for you</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}